import { render } from "./patient-history-tabs.vue?vue&type=template&id=5d1fc8eb&scoped=true"
import script from "./patient-history-tabs.vue?vue&type=script&lang=js"
export * from "./patient-history-tabs.vue?vue&type=script&lang=js"

import "./patient-history-tabs.vue?vue&type=style&index=0&id=5d1fc8eb&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1fc8eb"]])

export default __exports__